// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { FetchModelResponse, IFetchModel } from '@cian/http-api';
import type { IGetReviewsResponseV2Schema } from '../../entities/web_entities/GetReviewsResponseV2Schema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetReviewsRequest {
  /**  Можно отображать тестовые отзывы  **/
  canViewTest?: boolean;
  /**  Id последнего отзыва в списке отзывов  **/
  fromLastReviewId?: string;
  /**  Количество отзывов в выдаче  **/
  offset?: number;
  /**  Идентификатор пользователя, который является агентом  **/
  realtyUserId: number;
  /**  Тип сортировки, по умолчанию useful  **/
  sortType?: EQueryParameters;
}

export enum EQueryParameters {
  /** Сначала с наибольшей оценкой **/
  'MaxRate' = 'maxRate',
  /** Сначала с наименьшей оценкой **/
  'MinRate' = 'minRate',
  /** Сначала новые отзывы **/
  'New' = 'new',
  /** Сначала старые отзывы **/
  'Old' = 'old',
  /** Сортировка по полезности отзыва **/
  'Useful' = 'useful',
}
export type TGetReviewsResponse =
  | FetchModelResponse<200, 'json', IGetReviewsResponseV2Schema>
  | FetchModelResponse<400, 'json', IErrorResponseSchema>;

export type TGetReviewsModel = IFetchModel<IGetReviewsRequest, undefined, TGetReviewsResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetReviewsResponseV2Schema, headers: Headers): TResponse200;
  400(response: IErrorResponseSchema, headers: Headers): TResponse400;
}
